import React from 'react'

const Education = () => (
  <div className="row education">
    <div className="three columns header-col">
      <h1>
        <span>Education</span>
      </h1>
    </div>

    <div className="nine columns main-col">
      <div className="row item">
        <div className="twelve columns">
          <h3>University of Connecticut</h3>
          <p className="info">
            BSE. Computer Science and Engineering
            <span>&bull;</span>
            <em className="date">May 2013</em>
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>University of Connecticut</h3>
          <p className="info">
            BA. German Studies
            <span>&bull;</span>
            <em className="date">May 2013</em>
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>Ruprecht-Karls-Universität Heidelberg</h3>
          <p className="info">
            Deutsch als Fremdsprache (German as a Second Language)
            <span>&bull;</span>
            <em className="date">June 2012</em>
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default Education



// WEBPACK FOOTER //
// ./src/components/Education.js